/* eslint-disable */
import { createReducer, createActions } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */
const webSocketTypeAction = {
  loginRequest : null
, connecting : null
, loginFailure : null
, disconnected : ['event']
, connected : ['event']
, message : ['event']
, wserr : ['event']
, order : ['event']
, coupon : ['event']
}

const { Types, Creators } = createActions({
  ...webSocketTypeAction
})

export const WebSocketTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  ChatURL : ''
, Token : ''
, Waiting : false
, Connected : false
, error : null
, order : { UserId : '', Message : '', OrderId : '', Time : 0 }
, coupon : { UserId : '', Message : '', CouponId : '', Time : 0 }
})
export const FAILURE_STATE = Immutable({
  ChatUrl : ''
, Token : ''
, Waiting : false
, Connected : false
, error : 'Login Failure'
, order : { UserId : '', Message : '', OrderId : '', Time : 0 }
, coupon : { UserId : '', Message : '', CouponId : '', Time : 0 }
})

/* ------------- Reducers ------------- */
export const loginRequest = (state) => state.merge({ Waiting : true, error : null, Connected : false })
export const loginFailure = (state, action) => FAILURE_STATE
export const disconnected = (state, action) => INITIAL_STATE
export const wserr = (state, action) => state.merge({ Waiting : false, Connected : false, error : action })
export const connecting = (state, action) => state.merge({ Waiting : true, error : null, Connected : false })
export const connected = (state, action) => state.merge({ Waiting : false, Connected : true, error : null })
export const message = (state, action) => state
export const order = (state, action) => state.merge({ order : action.event })
export const coupon = (state, action) => state.merge({ coupon : action.event })

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CONNECTING] : connecting
, [Types.LOGIN_FAILURE] : loginFailure
, [Types.DISCONNECTED] : disconnected
, [Types.CONNECTED] : connected
, [Types.MESSAGE] : message
, [Types.WSERR] : wserr
, [Types.ORDER] : order
, [Types.COUPON] : coupon
})
